export enum UserHistoryPathway{
  Users = "0",
  ManageUser = "1"
}
